import { Injectable, inject } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { StorageKey } from '../shared/localstorage';

@Injectable({
  providedIn: 'root',
})
export default class LocalStorageService {
  private storage = inject<StorageService>(SESSION_STORAGE);

  anotherTodolist = [];

  public getLocalStorage(key: string): unknown {
    return this.storage.get(key) || [];
  }

  public saveLocalStorage(key: string, value: unknown): void {
    this.storage.set(key, value);
  }

  public clearLocalStorage(): void {
    const allKeys = Object.values(StorageKey);

    allKeys.forEach((role) => {
      this.storage.remove(role);
    });
  }
}
